import { styled } from "styled-components";
import { Label } from "./AccountBalanceInput";
import { Title } from "./ReceiptComponent";

interface PaymentDescriptionProps {
  title: string;
  description: string;
}
const PaymentDescription: React.FC<PaymentDescriptionProps> = ({
  title,
  description,
}) => {
  return (
    <SummaryWrapper>
      <div>
        <Title>{title}</Title>
      </div>
      <div>
        <Label>{description}</Label>
      </div>
    </SummaryWrapper>
  );
};

export default PaymentDescription;

export const SummaryWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
